const ksLoadScriptOnce = (src, { defer = true, integrity = '', crossorigin = '' } = {}) => {
  return new Promise((resolve, reject) => {
    const existingScript = document.querySelector(`script[src="${src}"]`)
 
    if (existingScript) {
      if (existingScript.dataset.ksLoaded === 'true') {
        resolve(existingScript)
        return
      }
 
      existingScript.addEventListener('load', () => resolve(existingScript), { once: true })
      existingScript.addEventListener('error', reject, { once: true })
      return
    }
 
    const script = document.createElement('script')
    script.src = src
    script.defer = defer
    script.dataset.ksExternal = 'true'
 
    if (integrity) script.integrity = integrity
    if (crossorigin) script.crossOrigin = crossorigin
 
    script.addEventListener('load', () => {
      script.dataset.ksLoaded = 'true'
      resolve(script)
    }, { once: true })
 
    script.addEventListener('error', reject, { once: true })
    document.head.appendChild(script)
  })
}
 
const ksLoadStyleOnce = (href, { integrity = '', crossorigin = '' } = {}) => {
  if (document.querySelector(`link[href="${href}"]`)) return
 
  const link = document.createElement('link')
  link.rel = 'stylesheet'
  link.href = href
  link.dataset.ksExternal = 'true'
 
  if (integrity) link.integrity = integrity
  if (crossorigin) link.crossOrigin = crossorigin
 
  document.head.appendChild(link)
}
 
const ksInitSubscriptionRadios = (scope = document) => {
  scope.querySelectorAll('.shopify_subscriptions_app_block [type="radio"]').forEach((radio) => {
    radio.classList.add('bs-form-check-input')
  })
}
 
class KsProductQuantityBreaks extends HTMLElement {
  connectedCallback () {
    if (this.dataset.ksInitialized === 'true') return
    this.dataset.ksInitialized = 'true'
 
    const productInfo = this.closest('product-info')
    if (!productInfo) return
 
    const buttonsWrapper = productInfo.querySelector('.product-form__buttons')
    const submitBtn = buttonsWrapper?.querySelector('button')
    let quantityField = productInfo.querySelector('input[name="quantity"]')
 
    if (!quantityField && buttonsWrapper) {
      buttonsWrapper.insertAdjacentHTML('beforebegin', '<input type="hidden" name="quantity" value="1">')
      quantityField = productInfo.querySelector('input[name="quantity"]')
    }
 
    if (!quantityField) return
 
    this.querySelectorAll('input').forEach((input) => {
      input.addEventListener('change', () => {
        quantityField.value = input.value
 
        if (!submitBtn || !this.dataset.btnAnimate) return
 
        window.setTimeout(() => {
          submitBtn.classList.add('animate__animated', this.dataset.btnAnimate)
        }, 250)
 
        window.setTimeout(() => {
          submitBtn.classList.remove('animate__animated', this.dataset.btnAnimate)
        }, 1500)
      })
    })
  }
}
 
if (!customElements.get('ks-product-quantity-breaks')) {
  customElements.define('ks-product-quantity-breaks', KsProductQuantityBreaks)
}
 
class KsStickyATC extends HTMLElement {
  connectedCallback () {
    if (this.dataset.ksInitialized === 'true') return
    this.dataset.ksInitialized = 'true'

    this.productInfo = this.closest('product-info') || this.findProductInfo()
    this.variantSelector = this.querySelector('select[name="id"]')
    this.mainVariantInput = this.productInfo?.querySelector('.product-form input[name="id"]')
    this.mainProductForm = this.productInfo?.querySelector('product-form')
    this.hasMountedInBody = false
    this.currentlyVisible = false
    this.ticking = false
    this.isSyncingFromMain = false
    this.isSyncingToMain = false

    if (!this.mainProductForm || !this.mainVariantInput) return

    this.scrollThreshold = this.mainProductForm.getBoundingClientRect().bottom + window.scrollY
    this.handleScroll = this.onScroll.bind(this)
    this.handleResize = this.onResize.bind(this)
    this.handleMainVariantChange = this.onMainProductFormVariantChange.bind(this)
    this.handleStickyVariantChange = this.onVariantChange.bind(this)

    if (this.variantSelector) {
      this.variantSelector.addEventListener('change', this.handleStickyVariantChange)
      this.variantSelector.value = this.mainVariantInput.value
      this.updateStickyVisualState()
    }

    this.mainVariantInput.addEventListener('change', this.handleMainVariantChange)
    window.addEventListener('scroll', this.handleScroll, { passive: true })
    window.addEventListener('resize', this.handleResize)

    this.onMainProductFormVariantChange()
    this.onScroll()
  }

  disconnectedCallback () {
    if (this.handleScroll) window.removeEventListener('scroll', this.handleScroll)
    if (this.handleResize) window.removeEventListener('resize', this.handleResize)
    if (this.variantSelector && this.handleStickyVariantChange) {
      this.variantSelector.removeEventListener('change', this.handleStickyVariantChange)
    }
    if (this.mainVariantInput && this.handleMainVariantChange) {
      this.mainVariantInput.removeEventListener('change', this.handleMainVariantChange)
    }
    if (this.currentlyVisible) this.clearBodyOffset()
  }

  findProductInfo () {
    const sectionId = this.dataset.sectionId
    if (!sectionId) return document.querySelector('product-info')
    return document.querySelector(`product-info[data-section="${sectionId}"]`)
  }

  onResize () {
    if (!this.mainProductForm) return
    this.scrollThreshold = this.mainProductForm.getBoundingClientRect().bottom + window.scrollY
    if (this.currentlyVisible) this.syncBodyOffset()
    this.onScroll()
  }

  syncBodyOffset () {
    const height = Math.ceil(this.getBoundingClientRect().height)
    document.body.style.paddingBottom = `${height}px`
    document.documentElement.style.setProperty('--bn-sticky-atc-height', `${height}px`)
    document.body.classList.add('bn-sticky-atc-visible')
  }

  clearBodyOffset () {
    document.body.style.paddingBottom = '0px'
    document.documentElement.style.removeProperty('--bn-sticky-atc-height')
    document.body.classList.remove('bn-sticky-atc-visible')
  }

  onScroll () {
    if (this.ticking) return

    this.ticking = true
    window.requestAnimationFrame(() => {
      const shouldShow = window.scrollY > this.scrollThreshold

      if (shouldShow) {
        if (!this.hasMountedInBody) {
          document.body.insertAdjacentElement('beforeend', this)
          this.hasMountedInBody = true
        }

        if (!this.currentlyVisible) {
          this.classList.add('show')
          this.currentlyVisible = true
          window.requestAnimationFrame(() => this.syncBodyOffset())
        }
      } else if (this.currentlyVisible) {
        this.classList.remove('show')
        this.clearBodyOffset()
        this.currentlyVisible = false
      }

      this.ticking = false
    })
  }

  parseSelectedOptionValues () {
    const selectedOption = this.variantSelector?.options[this.variantSelector.selectedIndex]
    if (!selectedOption?.dataset.optionValues) return []

    try {
      const values = JSON.parse(selectedOption.dataset.optionValues)
      return Array.isArray(values) ? values : []
    } catch (error) {
      console.error('[Brillo Nativo] No fue posible leer las opciones de la variante del sticky.', error)
      return []
    }
  }

  applyVariantOptionsToMainPicker (optionValues) {
    const variantSelects = this.productInfo?.querySelector('variant-selects')
    if (!variantSelects || !optionValues.length) return false

    const optionGroups = Array.from(variantSelects.querySelectorAll('.product-form__input'))
    if (optionValues.length > optionGroups.length) return false

    let eventTarget = null
    let allOptionsApplied = true

    optionValues.forEach((optionValue, index) => {
      const optionGroup = optionGroups[index]
      if (!optionGroup) {
        allOptionsApplied = false
        return
      }

      const select = optionGroup.querySelector('select')
      if (select) {
        const matchingOption = Array.from(select.options).find((option) => option.value === optionValue)
        if (!matchingOption) {
          allOptionsApplied = false
          return
        }

        Array.from(select.options).forEach((option) => {
          option.toggleAttribute('selected', option === matchingOption)
        })
        select.value = optionValue
        eventTarget = select
        return
      }

      const radios = Array.from(optionGroup.querySelectorAll('input[type="radio"]'))
      const matchingRadio = radios.find((input) => input.value === optionValue)

      if (!matchingRadio) {
        allOptionsApplied = false
        return
      }

      radios.forEach((radio) => {
        radio.checked = radio === matchingRadio
      })
      eventTarget = matchingRadio
    })

    if (!allOptionsApplied || !eventTarget) return false

    eventTarget.dispatchEvent(new Event('change', { bubbles: true }))
    return true
  }

  updateStickyVisualState () {
    if (!this.variantSelector) return

    const selectedOption = this.variantSelector.options[this.variantSelector.selectedIndex]
    const imgSrc = selectedOption?.dataset.variantImg
    const variantAvailable = selectedOption?.dataset.variantAvailable !== 'false' && !selectedOption?.disabled
    const img = this.querySelector('.ks-sticky-atc-img')
    const submitButton = this.querySelector('button[type="submit"][name="add"]')
    const submitButtonLabel = submitButton?.querySelector('span')

    if (img && imgSrc) img.src = imgSrc

    if (submitButton) {
      submitButton.disabled = !variantAvailable
      submitButton.setAttribute('aria-disabled', variantAvailable ? 'false' : 'true')
    }

    if (submitButtonLabel && window.variantStrings) {
      submitButtonLabel.textContent = variantAvailable
        ? window.variantStrings.addToCart
        : window.variantStrings.soldOut
    }
  }

  onVariantChange (event) {
    event.preventDefault()
    if (!this.variantSelector) return

    this.updateStickyVisualState()

    if (this.isSyncingFromMain || this.isSyncingToMain) return

    const optionValues = this.parseSelectedOptionValues()
    if (!optionValues.length) return

    this.isSyncingToMain = true
    const applied = this.applyVariantOptionsToMainPicker(optionValues)
    this.isSyncingToMain = false

    if (!applied) {
      console.error('[Brillo Nativo] No fue posible sincronizar la variante del sticky con el selector principal.')
    }
  }

  onMainProductFormVariantChange () {
    if (!this.variantSelector || !this.mainVariantInput) return

    this.isSyncingFromMain = true
    this.variantSelector.value = this.mainVariantInput.value
    this.updateStickyVisualState()
    this.isSyncingFromMain = false
  }
}
 
if (!customElements.get('ks-sticky-atc')) {
  customElements.define('ks-sticky-atc', KsStickyATC)
}
 
class KsProductPrevNext extends HTMLElement {
  static floatingUiPromise = null
 
  connectedCallback () {
    if (this.dataset.ksInitialized === 'true') return
    this.dataset.ksInitialized = 'true'
 
    if (window.matchMedia('(min-width: 750px)').matches) {
      document.body.insertAdjacentElement('beforeend', this)
    }
 
    this.init()
  }
 
  async init () {
    await this.ensureFloatingUi()
 
    this.querySelectorAll('.ks-product-block-prev-next-inner').forEach((element) => {
      this.handleTooltip(element)
    })
  }
 
  ensureFloatingUi () {
    if (window.FloatingUIDOM?.computePosition && window.FloatingUIDOM?.offset) {
      return Promise.resolve()
    }
 
    if (!KsProductPrevNext.floatingUiPromise) {
      KsProductPrevNext.floatingUiPromise = (async () => {
        await ksLoadScriptOnce('https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.8', {
          crossorigin: 'anonymous'
        })
        await ksLoadScriptOnce('https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.8', {
          crossorigin: 'anonymous'
        })
      })()
    }
 
    return KsProductPrevNext.floatingUiPromise
  }
 
  handleTooltip (element) {
    const button = element.querySelector('a')
    const tooltip = element.querySelector('.ks-tooltip')
 
    if (!button || !tooltip) return
 
    const update = async () => {
      if (!window.FloatingUIDOM?.computePosition) return
 
      const { x, y } = await window.FloatingUIDOM.computePosition(button, tooltip, {
        middleware: [
          window.FloatingUIDOM.offset(10),
          window.FloatingUIDOM.autoPlacement()
        ]
      })
 
      Object.assign(tooltip.style, {
        left: `${x}px`,
        top: `${y}px`
      })
    }
 
    const showTooltip = async () => {
      await this.ensureFloatingUi()
      await new Promise((resolve) => window.setTimeout(resolve, 200))
      tooltip.classList.add('show')
      update()
    }
 
    const hideTooltip = () => {
      window.setTimeout(() => {
        tooltip.classList.remove('show')
        tooltip.classList.add('hiding')
 
        window.setTimeout(() => {
          tooltip.classList.remove('hiding')
        }, 200)
      }, 100)
    }
 
    ;[
      ['mouseenter', showTooltip],
      ['mouseleave', hideTooltip],
      ['focus', showTooltip],
      ['blur', hideTooltip]
    ].forEach(([eventName, listener]) => {
      button.addEventListener(eventName, listener)
    })
  }
}
 
if (!customElements.get('ks-product-prev-next')) {
  customElements.define('ks-product-prev-next', KsProductPrevNext)
}
 
class KsPersonalizationField extends HTMLElement {
  constructor () {
    super()
 
    this.form = document.querySelector('form[data-type="add-to-cart-form"]')
    if (!this.form) return
 
    this.type = this.dataset.type
  }
}
 
class KsPersonalizationFieldFileUpload extends HTMLElement {
  static dependenciesPromise = null
 
  connectedCallback () {
    if (this.dataset.ksInitialized === 'true') return
    this.dataset.ksInitialized = 'true'
 
    this.ensureDependencies()
      .then(() => this.init())
      .catch(() => {})
 
    window.addEventListener('ks.product.quick_view.modal_shown', () => this.init(), { passive: true })
  }
 
  ensureDependencies () {
    if (window.FilePond && window.FilePondPluginImagePreview) {
      return Promise.resolve()
    }
 
    if (!KsPersonalizationFieldFileUpload.dependenciesPromise) {
      ksLoadStyleOnce('https://cdn.jsdelivr.net/npm/filepond@4.31.1/dist/filepond.min.css', {
        integrity: 'sha256-a95jYCBL4++k1XyLYgulKmY33bIJIVYMsJO/RNytaJM=',
        crossorigin: 'anonymous'
      })
      ksLoadStyleOnce('https://cdn.jsdelivr.net/npm/filepond-plugin-image-preview@4.6.12/dist/filepond-plugin-image-preview.min.css', {
        integrity: 'sha256-YsO8aMI20vSizdmc2mmWx2DU1wof4v60Nwy7hIBvdM8=',
        crossorigin: 'anonymous'
      })
 
      KsPersonalizationFieldFileUpload.dependenciesPromise = Promise.all([
        ksLoadScriptOnce('https://cdn.jsdelivr.net/npm/filepond@4.31.1/dist/filepond.min.js', {
          integrity: 'sha256-6yXpr8+sATA4Q2ANTyZmpn4ZGP7grbIRNpe9s0Y+iO0=',
          crossorigin: 'anonymous'
        }),
        ksLoadScriptOnce('https://cdn.jsdelivr.net/npm/filepond-plugin-image-preview@4.6.12/dist/filepond-plugin-image-preview.min.js', {
          integrity: 'sha256-1vQHytMrpOsKFyUUPuEVhxeNH6UhMX3uNetDRvlSpwU=',
          crossorigin: 'anonymous'
        })
      ])
    }
 
    return KsPersonalizationFieldFileUpload.dependenciesPromise
  }
 
  async init () {
    if (this.dataset.ksPondReady === 'true') return
    if (!window.FilePond || !window.FilePondPluginImagePreview) return
 
    const inputElement = this.querySelector('input[type="file"]')
    if (!inputElement) return
 
    this.dataset.ksPondReady = 'true'
    window.FilePond.registerPlugin(window.FilePondPluginImagePreview)
 
    const labelText = this.querySelector('[data-label-text]')?.innerHTML || ''
    const pond = window.FilePond.create(inputElement, {
      storeAsFile: true,
      labelIdle: labelText
    })
 
    pond.on('addfile', () => {
      window.setTimeout(() => {
        const fileData = this.querySelector('.filepond--data')
        const productForm = this.closest('.product')?.querySelector('.product-form form')
 
        if (fileData && productForm) {
          productForm.insertAdjacentElement('beforeend', fileData)
        }
      }, 1000)
    })
  }
}
 
if (!customElements.get('ks-personalization-field-file-upload')) {
  customElements.define('ks-personalization-field-file-upload', KsPersonalizationFieldFileUpload)
}
 
const ksInitProductEnhancements = (scope = document) => {
  ksInitSubscriptionRadios(scope)
}
 
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => ksInitProductEnhancements(), { once: true })
} else {
  ksInitProductEnhancements()
}
 
document.addEventListener('shopify:section:load', (event) => {
  ksInitProductEnhancements(event.target)
})